import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";

import { sendMilestonePaymentReminder } from "../services/goHireService";

export const useSendMilestonePaymentReminder = (contractId: number, options?: { onSuccess?: () => void }) => {
  const { t } = useTranslation("goService", { keyPrefix: "createContractPage" });

  return useMutation({
    mutationFn: () => sendMilestonePaymentReminder(contractId),
    onSuccess: () => {
      toast.success(t("milestonePaymentReminderSent"));
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
